import { render, staticRenderFns } from "./jyzx.vue?vue&type=template&id=485f0215&scoped=true&"
import script from "./jyzx.vue?vue&type=script&lang=js&"
export * from "./jyzx.vue?vue&type=script&lang=js&"
import style0 from "./jyzx.vue?vue&type=style&index=0&id=485f0215&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f0215",
  null
  
)

export default component.exports